(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativeUpdateStatusReviewDeliverablesByQuarterController', Controller);

    Controller.$inject = ['$scope', 'topBarService', 'govProcess', 'assessmentByInitiative', 'deliverableAssessmentsByQuarter', 'fiscalYearQuarterKeys'];

    function Controller($scope, topBarService, govProcess, assessmentByInitiative, deliverableAssessmentsByQuarter, fiscalYearQuarterKeys) {

        topBarService.setTitleAndIcon('Business Planning', 'fa fa-compass');
        $scope.govProcess = govProcess;

        $scope.ctrlCtxt = {};

        $scope.assessmentByInitiative  = _.omit(assessmentByInitiative, 'PlanDeliverableAssessments');
        $scope.initiativesList = assessmentByInitiative.InitiativesList;
        $scope.planInitiativeAssessment = assessmentByInitiative.PlanInitiativeAssessment;
        $scope.deliverableAssessmentsByQuarter = deliverableAssessmentsByQuarter;

        $scope.fiscalYearQuarterKeys = fiscalYearQuarterKeys;
        $scope.planInitiative = assessmentByInitiative.PlanInitiative;

        $scope.canEdit = true;
    }
})();